// @flow
// Libs
import React, { useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

// Utils
import getUrl from 'hfty-utils/url'

// Components
import { Dialog, DialogBody, DialogFooter, DialogHeader, DialogTitle } from 'react-mdc-web/lib/Dialog'
import Button from 'react-mdc-web/lib/Button'
import Check from 'fc-icons/src/Check'
import ErrorOutline from 'fc-icons/src/ErrorOutline'
import Spinner from 'react-spinkit'

// Constants
import { PROP_PAYMENT_SESSION_ID, SUBMITTED } from 'hfty-model-orders/src/constants'
import { URL } from 'hfty-model-orders/src/constants'

// Messages
import messages from 'hfty-checkout/src/messages'

// Styles
const styles = {
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  dialogBody: {
    overflow: 'auto',
    height: '200px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkIcon: {
    padding: 10,
    borderRadius: '50%',
    border: `5px solid ${'#6ecc0f'}`,
  },
  text: {
    whiteSpace: 'pre-line',
    fontSize: '1.125em',
    lineHeight: '1.5em',
    marginTop: '2em',
    color: 'black',
  },
  dialogSurface: {
    backgroundColor: 'white',
    width: '100%',
  },
  loader: {
    width: '60px',
    height: '60px',
    color: '#003265',
  },
}

export const PaymentStatusModal = (props) => {
  const { history, token, push } = props
  const sessionId = history && history.location ? history.location.search.split('=')[1] : null
  const success = {
    header: props.intl.formatMessage(messages['modalTitlePaymentSuccessful']),
    body: props.intl.formatMessage(messages['modalBodyPaymentSuccessful']),
    icon: <Check color={'#359706'} size={60} style={styles.checkIcon} />,
  }

  const error = {
    header: props.intl.formatMessage(messages['modalTitlePaymentFailed']),
    body: props.intl.formatMessage(messages['modalBodyPaymentFailed']),
    icon: <ErrorOutline color={'#f43636'} size={90} />,
  }

  const inProgress = {
    header: props.intl.formatMessage(messages['modalTitlePaymentPending']),
    body: props.intl.formatMessage(messages['modalBodyPaymentPending']),
    icon: <Spinner name="circle" style={styles.loader} />,
  }
  const [status, setStatus] = React.useState(inProgress)
  const onCloseHandler = () => {
    props.onClose()
    push('/')
  }

  useEffect(() => {
    if (sessionId) {
      fetch(
        getUrl({
          path: URL,
          queryParams: {
            [PROP_PAYMENT_SESSION_ID]: sessionId,
          },
        }),
        {
          headers: {
            Authorization: `Token ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const order = data && data[0]
          const status = order && order.status
          if (status === SUBMITTED) {
            setStatus(success)
          } else {
            setStatus(error)
          }
        })
        .catch((error) => {
          console.error('Error retrieving order:', error)
        })
    }
  }, [])

  return (
    <Dialog open={props.open} onClose={onCloseHandler} style={styles.dialog}>
      <div className="mdc-dialog__surface" style={styles.dialogSurface}>
        <DialogHeader>
          <DialogTitle>{status.header}</DialogTitle>
        </DialogHeader>
        <DialogBody style={styles.dialogBody}>
          {status.icon}
          <p style={styles.text}>{status.body}</p>
        </DialogBody>
        <DialogFooter>
          <Button raised primary onClick={onCloseHandler}>
            <FormattedMessage {...messages['continue']} />
          </Button>
        </DialogFooter>
      </div>
    </Dialog>
  )
}

export default injectIntl(PaymentStatusModal)
